module.exports = __webpack_public_path__ + "static/media/speaker6.ff3a6090.png";